import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginAgainComponent } from './login-again.component';

@NgModule({
  imports: [CommonModule],
  declarations: [LoginAgainComponent],
  exports: [LoginAgainComponent]
})
export class ModalLoginAgainModule { }



// WEBPACK FOOTER //
// ./src/app/shared/modules/modal-login-again/modal-login-again.module.ts